import { BehaviorType } from "../types";
import Behavior from "../types/Behavior";
class CopyBehavior extends Behavior {
    constructor(plasm, appName, addMetadata) {
        super(plasm, appName, addMetadata);
        this.id = BehaviorType.copy;
        this.iframeBehaviorListeners = [{ type: this.id, listener: this.handler }];
    }
}
export default CopyBehavior;
